import { primary } from 'rp-navigation';
/**
 * @name results.controller:directiveSelectDateCtrl
 * @description
 * # directiveSelectDateCtrl
 * Controller for select date directive
 */
export default function ($scope, $element, $window, userPreference, config) {
    'ngInject';

    $scope.MIN_DATE = '1988-01-01'; // The date from which the results starts
    $scope.TIME = '/time-order';
    $scope.datePickerClass = 'rp-datePicker';
    $scope.markedLinkClass = 'ui-link_marked';

    $scope.initialDate = $element.data('date');

    $scope.getInitialDatePickerObject = () => {
        const now = moment();

        const initialDatePicker = {
            date: $scope.initialDate || now,
            maxDate: now,
            minDate: $scope.MIN_DATE,
            monthPickerAutoClose: false,
            position: {
                my: 'top+16'
            },
            css: {
                picker: `ui-datePicker ${$scope.datePickerClass}`
            },
            autoClose: true
        };

        return initialDatePicker;
    };

    $scope.init = () => {
        $scope.datePicker = $element.datePicker($scope.getInitialDatePickerObject());

        $scope.datePicker.on('change.rp.datePicker', (event, date) => {
            const activeDate = primary.getItemByTitle('Results');
            const prevState = activeDate.stateManager.prevState;
            let url = `${config.get('resultsPath')}/${date.format('YYYY-MM-DD')}`;

            if (prevState && prevState.path) {
                url += `/${prevState.path}`;
            }

            $window.location.pathname = url;
        }).on('show.rp.datePicker', () => {
            $element.addClass($scope.markedLinkClass);
            jQuery('.rn-secondaryNav').removeClass('rn-secondaryNav_active');
            jQuery('.ui-overlay').remove();
        }).on('hide.rp.datePicker', () => {
            $element.removeClass($scope.markedLinkClass);
        });

        // Important: Add appropriate data-test-selectors for automation testing, don't miss it.
        angular.element(`.${$scope.datePickerClass}`)
            .attr('data-test-selector', 'block-datePickerStandAlone');
    };

    $scope.init();
}



// WEBPACK FOOTER //
// ./src/js/controllers/directiveSelectDate.js